// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b104109e","239":"611e80b8","455":"16e08afb"}[chunkId] + ".chunk.js";
};